import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const isModalOpenedSelector = (state: RootState) => state.mindlyReviews.isModalOpened;
export const isReviewedSelector = (state: RootState) => state.mindlyReviews.isReviewed;
